<template>
  <AppLayoutContainer class="update-block" v-if="data && visible">
    <div class="update-block__inner">

      <header class="update-block__header">
        <time v-if="computedPublishTime" class="update-block__time">{{ computedPublishTime.value }}</time>
        <span v-if="computedPublishTime && data.title" class="update-block__label"> - </span>
        <h2 v-if="data.title" class="update-block__title">{{ data.title }}</h2>
        <span v-if="data.badge" class="update-block__header-label"> - {{ data.badge }} </span>
      </header>

      <AppRichText v-if="data.text" :data="data.text" class="app-rich-text--introduction"/>
      <AppButton v-if="data.button_url" :url="data.button_url" :title="data.button_text" :end-icon="true" class="update-block__button"/>

    </div>
  </AppLayoutContainer>
</template>

<script setup lang="ts">

import {TArchiveInfoBlock} from "~/types/block-archive-types";
import {computed} from "vue";
import {isVisible, useDate} from "#imports";
import {TUpdateBlock} from "~/types/block-types";

const props = defineProps<{
  data: TArchiveInfoBlock | TUpdateBlock
}>()

const computedPublishTime = computed(() => {

  if (props.data?.start_time) {
    return useDate(props.data.start_time)
  } else {
    return useDate(props.data?.publish_time || props.data?.date_created)
  }
})

const computedAdjustTime = computed(() => {
  if (props.data?.adjust_time || props.data?.date_created) {
    return useDate(props.data?.adjust_time || props.data?.date_updated)
  }
})

const visible = computed(() => {
  return isVisible(props.data)
})

</script>

<style scoped lang="postcss">
.update-block {
  &__inner {
    @mixin app-blue-border-block;
  }

  &__header {
    margin-bottom: 0.5rem;
  }

  &__time {
    display: block;
    @mixin heading-h5-wide;

    @media (--sm) {
      display: inline;
    }
  }

  &__label {
    display: none;

    @media (--sm) {
      display: inline;
    }
  }

  &__title {
    display: inline;
    @mixin heading-h5-wide;
  }

  &__header-label {
    font-family: Graphik, sans-serif;
    font-weight: 400;
  }

  &__button {
    margin-top: 2rem;
  }
}
</style>
